import { types, getParent, type Instance, getRoot } from 'mobx-state-tree';

import type { AttachmentType } from 'src/App/AppPageBlock/ProfileDrawer/Profile/ProfileBody';
import type { IStore } from 'src/stores/Store';

import {
  ATTACHMENT_TYPES,
  getDisplayNameByType,
  getNameByType,
} from '../../constants/attachmentTypes';

const MAX_SHORT_NAME_LENGTH = 45;
// TODO_TYPES: can we do better?
interface PartialJobApplication {
  id: string;
}

const Attachment = types
  .model('Attachment', {
    id: types.string,
    type: types.number,
    filename: types.maybeNull(types.string),
    uploadedUser: types.maybeNull(types.string),
    uploadedDate: types.maybeNull(types.string),
  })
  .views((self) => ({
    get rootStore(): IStore {
      return getRoot(self);
    },
    get typeName() {
      return getNameByType(self.type);
    },
    get jobApplication() {
      return getParent(self, 3) as PartialJobApplication;
    },
    get hirerGraphType(): AttachmentType {
      switch (self.type) {
        case ATTACHMENT_TYPES.RESUME:
          return 'RESUME';
        case ATTACHMENT_TYPES.COVER_LETTER:
          return 'COVER_LETTER';
        case ATTACHMENT_TYPES.SELECTION_CRITERIA:
          return 'SELECTION_CRITERIA';
        case ATTACHMENT_TYPES.REFERENCE_CHECK:
          return 'REFERENCE_CHECK';
        default:
          return 'OTHER';
      }
    },
    get name() {
      // Manually uploaded attachments will have a filename
      if (self.filename) {
        return self.filename;
      }
      return getDisplayNameByType(self.type);
    },
  }))
  .views((self) => ({
    get shortName() {
      const nameLength = self.name.length;
      if (nameLength <= MAX_SHORT_NAME_LENGTH) {
        return self.name;
      }
      let splitIndex = self.name.lastIndexOf('.');
      if (splitIndex > 1) {
        splitIndex = splitIndex - 1;
      } else {
        splitIndex = nameLength - 5;
      }
      const splitString = '...';
      const firstPartIndexEnd =
        MAX_SHORT_NAME_LENGTH - (nameLength - splitIndex) - splitString.length;
      return `${self.name.slice(
        0,
        firstPartIndexEnd,
      )}${splitString}${self.name.slice(splitIndex, nameLength)}`;
    },
  }));

export interface IAttachment extends Instance<typeof Attachment> {}
export default Attachment;
